import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.confirm` dialog (icon + title + message + optional
// typed-match + footer). A distinct element from <Modal> (its own sizing/z-index).
export const styles = {
  dialog: {
    kVAEAm: "xixxii4",
    kbCHJM: "x1nrll8i",
    k87sOh: "xwa60dl",
    k3aq6I: "xrtidir",
    kY2c9j: "x1nh0kk4",
    kzqmXN: "x1mdu8ss",
    ks0D6T: "xek5uqk",
    kmVPX3: "x1bn5kwv",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kaIpWk: "x7tdnnd",
    kGVxlE: "xkqgayn",
    kSiTet: "xg01cxk",
    k33iCy: "xlshs6z",
    kmkexE: "x139s4k2",
    $$css: true
  },
  show: {
    kSiTet: "x1hc1fzr",
    k33iCy: "xnpuxes",
    k3aq6I: "x11lhmoz",
    $$css: true
  },
  ico: {
    kzqmXN: "x187nhsf",
    kZKoxP: "xn3w4p2",
    kaIpWk: "x4pepcl",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    k1K539: "x1hftx76",
    $$css: true
  },
  icoDanger: {
    kWkggS: "x8qqj1s",
    kMwMTN: "x2wi9gy",
    $$css: true
  },
  icoBrand: {
    kWkggS: "x48i0l6",
    kMwMTN: "x1459q0w",
    $$css: true
  },
  title: {
    kMv6JI: "xpc6l4x",
    kGuDYH: "x19d36u7",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    k1K539: "xzueoph",
    $$css: true
  },
  message: {
    kMwMTN: "xdxw5r1",
    kGuDYH: "x2ouz8m",
    kLWn49: "x1jjo3f5",
    k1K539: "xrn58dq",
    $$css: true
  },
  match: {
    k1K539: "x1cg34oi",
    k9WMMc: "xdpxx8g",
    $$css: true
  },
  foot: {
    k1xSpc: "x78zum5",
    kjj79g: "x13a6bvl",
    kOIVth: "x1mnnc3i",
    $$css: true
  }
};